import TourV2UrgencyTags from 'components/Tours/TourV2UrgencyTags'
import useCheapestOfTourV2Offer from 'hooks/TourV2/useCheapestOfTourV2Offer'
import useTourTags from 'hooks/TourV2/useTourTags'
import React from 'react'

interface Props {
  offer: Tours.V2Offer
}

function TourUrgencyLabels({ offer }: Props) {
  const { cheapestPurchasableOption } =
    useCheapestOfTourV2Offer(offer)
  const tags = useTourTags(offer)

  return (
    <TourV2UrgencyTags
      tags={tags}
      className="labels-area"
      cheapestPurchasableOption={cheapestPurchasableOption}
      offer={offer}
    />
  )
}

export default TourUrgencyLabels
